module.exports = __webpack_public_path__ + "img/情感.fcae065f.svg";